import * as CONST from '../const';
import FormElementRenderer from './form.el';
const LOW_IMAGE_QUALITY_MESSAGE_CLASS = 'low-image-quality-message';
const IMAGE_SIZE_FORM_FIELD = 'image-size-form-field';
class FormElementSizeRenderer extends FormElementRenderer {
    render(option, cont, index) {
        const hidden = this.getHiddenClass(option), inDigital = this.checkIfOptionIsDigital(option) ? 'digital' : '', inRolled = this.checkIfOptionIsRolled(option) ? 'rolled' : '', el = document.createElement('div');
        el.id = `option_${option.optionName}`;
        [IMAGE_SIZE_FORM_FIELD, 'text-center', CONST.OPT_CLASS_OPTION_WIDE, inDigital, inRolled, hidden].forEach(name => name && el.classList.add(name));
        el.innerHTML = `<div style="margin-top: 1.5em;">Размер:
           <input type="number" step="5" tabindex="1" min="${CONST.SIZE_MIN}" style="width:90px;font-size: 1.2em;" value="${CONST.DEFAULT_SIZE_WIDTH}" id="size_free_width" /> X <input type="number" step="5" min="${CONST.SIZE_MIN}" style="width:90px;font-size: 1.2em;"  tabindex="2" value="${CONST.DEFAULT_SIZE_HEIGHT}" id="size_free_height" />
        </div>
        <div class="${LOW_IMAGE_QUALITY_MESSAGE_CLASS}">${CONST.MSG_LOW_IMAGE_QUALITY}</div>
        `;
        cont.appendChild(el);
        const elWidth = document.querySelector(`#size_free_width`);
        if (elWidth) {
            elWidth.addEventListener(`change`, (e) => this.onFreeSizeWidthChange(e));
            elWidth.addEventListener(`keypress`, (e) => this.preventSubmit(e));
            elWidth.addEventListener(`keydown`, (e) => this.preventSubmit(e));
            elWidth.addEventListener(`keyup`, (e) => this.preventSubmitAndMoveFocus(e.target, e));
        }
        const elHeight = document.querySelector(`#size_free_height`);
        if (elHeight) {
            elHeight.addEventListener(`change`, (e) => this.onFreeSizeHeightChange(e));
            elHeight.addEventListener(`keypress`, (e) => this.preventSubmit(e));
            elHeight.addEventListener(`keydown`, (e) => this.preventSubmit(e));
            elHeight.addEventListener(`keyup`, (e) => this.preventSubmitAndMoveFocus(e.target, e));
        }
        this.bindTooltip(option);
    }
    updateFromSummary(option, summary) {
        const id = `option_${option.optionName}`;
        const el = document.querySelector(`#${id}`);
        if (el !== null) {
            const hInp = el.querySelector('#size_free_height');
            if (hInp) {
                hInp.value = (summary.height || 0).toString();
            }
            const wInp = el.querySelector('#size_free_width');
            if (wInp) {
                wInp.value = (summary.width || 0).toString();
            }
            // el && this.updateLowImageQualityMessage(el as HTMLElement, summary.imageQuality || 0);
        }
    }
    updateLowImageQualityMessage(el, imageQuality) {
        if (imageQuality === -1) {
            this.showLowImageQualityMessage(el);
        }
        else {
            this.hideLowImageQualityMessage(el);
        }
    }
    showLowImageQualityMessage(el) {
        el.querySelector('.' + LOW_IMAGE_QUALITY_MESSAGE_CLASS)?.classList.add('image-quality-low');
    }
    hideLowImageQualityMessage(el) {
        el.querySelector('.' + LOW_IMAGE_QUALITY_MESSAGE_CLASS)?.classList.remove('image-quality-low');
    }
    preventSubmit(e) {
        if (e.keyCode === 13) {
            e.stopPropagation();
            return false;
        }
        else {
            return true;
        }
    }
    preventSubmitAndMoveFocus(el, e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            let context = el;
            while (context.tagName !== 'FORM' && context.parentNode) {
                context = context.parentNode;
            }
            const list = context.querySelectorAll('select, input');
            let i = 0;
            if (list.length > 0) {
                while (i < list.length) {
                    const formEl = list[i];
                    if (formEl === el) {
                        list[i + 1].focus();
                        break;
                    }
                    i++;
                }
            }
            return false;
        }
        else {
            return true;
        }
    }
    onFreeSizeWidthChange(e) {
        if (e.target) {
            const el = e.target;
            //const quality = 
            this.owner.onFreeSizeWidthChange(parseInt(el.value));
            //this.updateLowImageQualityMessage(el.closest('.'+IMAGE_SIZE_FORM_FIELD), quality);
        }
    }
    onFreeSizeHeightChange(e) {
        if (e.target) {
            const el = e.target;
            //const quality = 
            this.owner.onFreeSizeHeightChange(parseInt(el.value));
            //this.updateLowImageQualityMessage(el.closest('.'+IMAGE_SIZE_FORM_FIELD), quality);
        }
    }
}
export default FormElementSizeRenderer;
